import Vue from 'vue'
import Vuex from 'vuex'
import { STORAGE_KEY, APPLICANT_STATUS, APPLY_STATUS } from '@/data/default'
import { influencerList, campaignListBusiness } from '@/data/business'
import { campaignListInfluence } from '@/data/influencer'

Vue.use(Vuex)

if (!Storage.fetch(STORAGE_KEY.influencerList).length) Storage.store(STORAGE_KEY.influencerList, influencerList)
if (!Storage.fetch(STORAGE_KEY.campaignListBusiness).length) Storage.store(STORAGE_KEY.campaignListBusiness, campaignListBusiness)
if (!Storage.fetch(STORAGE_KEY.campaignListInfluence).length) Storage.store(STORAGE_KEY.campaignListInfluence, campaignListInfluence)

let today = new Date()
let formattedDate = today.toLocaleDateString('en-US').replace(/(\d{1,2})\/(\d{1,2})\/(\d{4})/, '$1/$2/$3')

export default new Vuex.Store({
  state: {
    influencerList: Storage.fetch(STORAGE_KEY.influencerList),
    campaignListBusiness: Storage.fetch(STORAGE_KEY.campaignListBusiness),
    campaignListInfluence: Storage.fetch(STORAGE_KEY.campaignListInfluence),
  },
  actions: {
    rejectApplicant({ commit, state }, rejectId) {
      const formatList = state.influencerList.filter(applicant => applicant.id !== rejectId)
      commit('setApplicantList', formatList)
    },
    updateApplicant({ commit }, payload) {
      commit('setApplicantEach', payload)
    },
    createCampaign({ commit }, payload) {
      commit('updateCampaignListBusiness', payload)
    },
    rejectCampaign({ commit, state }, rejectId) {
      const formatList = state.campaignListInfluence.filter(campaign => campaign.id !== rejectId)
      commit('setAppliedCampaignList', formatList)
    },
    updateCampaign({ commit }, payload) {
      commit('setCampaignEach', payload)
    },
    updateInfluencer({ commit }, payload) {
      commit('setInfluencerEach', payload)
    },
	},
	mutations: {
    setApplicantList(state, payload) {
      state.influencerList = payload
      Storage.store(STORAGE_KEY.influencerList, payload)
    },
    setApplicantEach(state, payload) {
      const { id, status, isChangeLiked } = payload
      const influencerIndex = state.influencerList.findIndex(applicant => applicant.id === id)
      if (status) state.influencerList[influencerIndex].status = status
      if (status === APPLICANT_STATUS.Matched) state.influencerList[influencerIndex].matchedDate = formattedDate
      if (isChangeLiked !== undefined) {
        state.influencerList[influencerIndex].isLiked = !state.influencerList[influencerIndex].isLiked
      }
      Storage.store(STORAGE_KEY.influencerList, state.influencerList)
    },
    updateCampaignListBusiness(state, payload) {
      state.campaignListBusiness.push(payload)
      Storage.store(STORAGE_KEY.campaignListBusiness, state.campaignListBusiness)
    },
    setAppliedCampaignList(state, payload) {
      state.campaignListInfluence = payload
      // Storage.store(STORAGE_KEY.appliedCampaignList, payload)
    },
    setCampaignEach(state, payload) {
      const { id, status, isChangeLiked } = payload
      const campaignIndex = state.campaignListInfluence.findIndex(campaign => campaign.id === id)
      if (status) state.campaignListInfluence[campaignIndex].status = status
      if (status === APPLY_STATUS.Matched) state.campaignListInfluence[campaignIndex].matchedDate = formattedDate
      if (isChangeLiked !== undefined) state.campaignListInfluence[campaignIndex].isLiked = !state.campaignListInfluence[campaignIndex].isLiked
      Storage.store(STORAGE_KEY.campaignListInfluence, state.campaignListInfluence)
    },
    setInfluencerEach(state, payload) {
      const { id, status, isChangeLiked } = payload
      const influencerIndex = state.influencerList.findIndex(influencer => influencer.id === id)
      const syncApplicantIndex = state.influencerList.findIndex(applicant => applicant.id === id)
      if (status) state.influencerList[influencerIndex].status = status
      if (status === APPLICANT_STATUS.Matched) state.influencerList[influencerIndex].matchedDate = formattedDate
      if (isChangeLiked !== undefined) {
        state.influencerList[influencerIndex].isLiked = !state.influencerList[influencerIndex].isLiked
        state.influencerList[syncApplicantIndex].isLiked = state.influencerList[influencerIndex].isLiked
      }
      Storage.store(STORAGE_KEY.influencerList, state.influencerList)
      Storage.store(STORAGE_KEY.influencerList, state.influencerList)
    },
	},
	getters: {
    applicantListPending: state => {
      return state.influencerList.filter(applicant => applicant.status === APPLICANT_STATUS.Pending)
    },
    applicantListInvited: state => {
      return state.influencerList.filter(applicant => applicant.status === APPLICANT_STATUS.Invited)
    },
    applicantListMatched: state => {
      return state.influencerList.filter(applicant => applicant.status === APPLICANT_STATUS.Matched)
    },
    campaignListInfluencePending: state => {
      return state.campaignListInfluence.filter(campaign => campaign.status === APPLY_STATUS.Pending)
    },
    campaignListInfluenceApplied: state => {
      return state.campaignListInfluence.filter(campaign => campaign.status === APPLY_STATUS.Applied)
    },
    campaignListInfluenceMatched: state => {
      return state.campaignListInfluence.filter(campaign => campaign.status === APPLY_STATUS.Matched)
    },
    campaignListInfluenceProgress: state => {
      return state.campaignListInfluence.filter(campaign => campaign.status === APPLY_STATUS.Matched && campaign.currentStep === 4)
    },
    campaignListInfluenceSearch: state => {
      return state.campaignListInfluence.filter(campaign => campaign.status === APPLY_STATUS.Default)
    },
    influencerListLiked: state => {
      return state.influencerList.filter(influencer => influencer.isLiked)
    },
    campaignListLiked: state => {
      return state.campaignListInfluence.filter(campaign => campaign.isLiked)
    },
  }
})